import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthProvider from "./contexts/AuthProvider";
import DataProvider from "./contexts/DataProvider";
import ErrorProvider from "./contexts/ErrorProvider";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import Dashboard from "./Dashboard";
import NotFound from "./NotFound";
import OrderHistory from "./order/OrderHistory";
import NewOrder from "./order/NewOrder";
import AllEmployees from "./employee/AllEmployees";
import AllBranches from "./branch/AllBranches";
import AllInvoices from "./invoice/AllInvoices";
import AllTransactions from "./wallet/AllTransactions";
import LoaderProvider from "./contexts/LoaderProvider";
import BranchSwitchProvider from "./contexts/BranchSwitchProvider";
import SidebarProvider from "./contexts/SidebarProvider";
import Settings from "./settings/Settings";
import AllWebhooks from "./webhook/AllWebhooks";
import useSingleTab from "./hooks/useSingleTab";
import UpdateNotifier from "./layout/UpdateNotifier";
import PaymentStatus from "./bookeey/PaymentStatus";

const App = () => {
  const blocked = useSingleTab();

  if (blocked) {
    return (
      <div style={{ textAlign: "center", marginTop: 100 }}>
        <h2>Already open in another tab</h2>
        <p>Please close the other tab and refresh to continue.</p>
      </div>
    );
  }
  return (
    <>
      <UpdateNotifier />
      <BrowserRouter>
        <SidebarProvider>
          <BranchSwitchProvider>
            <LoaderProvider>
              <AuthProvider>
                <DataProvider>
                  <ErrorProvider>
                    <Routes>
                      <Route path="/">
                        <Route index element={<Login />} />
                        <Route
                          path="forgot-password"
                          element={<ForgotPassword />}
                        />
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route
                          path="order-history"
                          element={<OrderHistory />}
                        />
                        <Route path="new-order" element={<NewOrder />} />
                        <Route path="employees" element={<AllEmployees />} />
                        <Route path="branches" element={<AllBranches />} />
                        <Route path="invoices" element={<AllInvoices />} />
                        <Route path="wallet" element={<AllTransactions />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="webhooks" element={<AllWebhooks />} />
                        <Route
                          path="bookeey-payment-status"
                          element={<PaymentStatus />}
                        />
                      </Route>
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </ErrorProvider>
                </DataProvider>
              </AuthProvider>
            </LoaderProvider>
          </BranchSwitchProvider>
        </SidebarProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
